
import * as utils from 'app/utils'
import { ServiceError, WebServiceBase, WebServiceResponse } from '../WebServiceBase'

// supply some error messages for our domains
ServiceError.domainCatalogs.Users = {
  100: 'This account already exists',
  101: 'Your account has expired',
  102: 'The information that you entered does not match any known account',
  103: 'The password reset has expired',
  104: 'The password reset is invalid',
  105: 'The user ID is invalid',
  106: 'The user id already exists',
  107: 'You aren\'t allowed to impesonate a user'
}

interface IPotentialUserRequest {
  Initial: string
  Lastname: string
  UniqueID: any
}

interface IResetPasswordRequest extends IPotentialUserRequest {
  Password: string
}

class UsersResponse extends WebServiceResponse {
  public static fromJSON(raw: any): UsersResponse {
    const r = new UsersResponse();
    r.deserialize(raw);
    return r;
  }

  public UserID: string
  public RealEmail: string
  public AccessToken: string
  public CustomerName: string
}

type CreateResponse = UsersResponse
type LoginResponse = UsersResponse

// tslint:disable-next-line:max-classes-per-file
class IsPotentialUserResponse extends WebServiceResponse {
  public static fromJSON(raw: any): IsPotentialUserResponse {
    const r = new IsPotentialUserResponse();
    r.deserialize(raw);
    return r;
  }

  public isPotentialUser: boolean
  public username: string

  deserialize(raw: any) {
    super.deserialize(raw)
    this.username = raw.Email
    this.isPotentialUser = !this.IsError
    return this
  }
}

// tslint:disable-next-line:max-classes-per-file
export class IsValidAuthTokenResponse extends WebServiceResponse {
  public static fromJSON(raw: any): IsValidAuthTokenResponse {
    const r = new IsValidAuthTokenResponse();
    r.deserialize(raw);
    return r;
  }

  public isValidAuthToken: boolean;
  public UserID: string;
  public AccessToken: string;
}

// tslint:disable-next-line:max-classes-per-file
class AccountsService extends WebServiceBase {
  protected apiEndpoint: string;

  constructor(protected serviceEndpoint: string) {
    super();
    this.apiEndpoint = this.serviceEndpoint + 'api/accounts/';
    // tslint:disable-next-line:no-console
    //console.log('AccountsService endpoint is at ' + this.apiEndpoint);
  }

  createUser(args: any): Promise<LoginResponse> {
    const uri = this.apiEndpoint + 'create';
    const req = this.requestOptions(uri, args);
    return utils.xfetch(req)
      .then(this.trace())
      .then((response) => response.json())
      .then(UsersResponse.fromJSON)
      .then((lr: LoginResponse) => {
        if (lr.IsError) { throw lr; }
        // tslint:disable-next-line:no-console
        console.log('create worked. ' + JSON.stringify(lr));
        gtag('set', {user_id: lr.UserID});
        return lr;
      }, (reason: any) => {
        // tslint:disable-next-line:no-console
        console.log('create failed. ' + JSON.stringify(reason));
        throw reason;
      });
  }

  /**
   *  Determine of this might be a potential user. Promise-based.
   *
   *  @param args - the arguments needed (like lastname, first initial, last 2 of social)
   *
   *  @return true, if this represents a potential user.
   */
  isPotentialUser(args: IPotentialUserRequest): Promise<IsPotentialUserResponse> {
    const uri = this.apiEndpoint + 'isPotentialUser';
    const req = this.requestOptions(uri, args);
    return utils.xfetch(req)
      .then(this.trace())
      .then((response) => response.json())
      .then(IsPotentialUserResponse.fromJSON)
  }

  isValidAuthToken(token: string): Promise<IsValidAuthTokenResponse> {
    const uri = this.apiEndpoint + 'isValidAuthToken';
    const body = {
      token,
      lifeExpectancy: 2 * 60 * 60
    };
    const req = this.requestOptions(uri, body);
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(IsValidAuthTokenResponse.fromJSON)
      .then((vr: IsValidAuthTokenResponse) => {
        if (vr.IsError) { throw vr; }
        //console.log("isValidAuthToken worked. " + JSON.stringify(vr));
        gtag('set', {user_id: vr.UserID});
        return vr;
      }, (reason: any) => {
        // tslint:disable-next-line:no-console
        console.log('isValidAuthToken failed. ' + JSON.stringify(reason));
        throw reason;
      });
  }

  /**
   *  Authenticate a login and return the IFamily information. Promise-based.
   *
   *  @param args - the arguments (like username and password needed to authenticate)
   *
   *  @returns The IFamily information (or fails the promise).
   */
  login(username: string, password: string): Promise<LoginResponse> {
    const uri = this.apiEndpoint + 'login';
    const body = {
      username,
      password
    };
    const req = this.requestOptions(uri, body);
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(UsersResponse.fromJSON)
      .then((lr: LoginResponse) => {
        if (lr.IsError) { throw lr; }
        //console.log("login worked. " + JSON.stringify(lr));
        gtag('set', {user_id: lr.UserID});
        return lr;
      }, (reason: any) => {
        // tslint:disable-next-line:no-console
        console.log('login failed. ' + JSON.stringify(reason));
        throw reason;
      });
  }

  resetPassword(args: IResetPasswordRequest): Promise<LoginResponse> {
    const uri = this.apiEndpoint + 'resetPassword';
    const req = this.requestOptions(uri, args);
    return utils.xfetch(req)
      .then(this.trace())
      .then((response) => response.json())
      .then(UsersResponse.fromJSON)
  }

}

export {
  AccountsService,
  CreateResponse,
  LoginResponse,
  IPotentialUserRequest,
  IResetPasswordRequest
}



// WEBPACK FOOTER //
// ./src/app/services/AccountsService/index.ts